module.exports = "/_next/static/images/banner_icon_early_change-79fccac0ea712306839a859190f929d7.svg";